import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import { useSelector } from 'react-redux'
import { getGroupsAPI } from '../../services/division'
import AddDivsion from '../../components/setting/org-setting/group/create-new'
import Index from '../../components/setting/org-setting/group/index'
import { useDebounce } from '@react-hook/debounce'
import { Link, useSearchParams } from 'react-router-dom'
import { BsFillDiagram3Fill, BsPlusLg, BsSearch } from 'react-icons/bs'
import NavRoleOrg from '../../components/nav-role-org'
import TextNavTitle from '../../components/TextNavTitle'
import CardCustom from '../../components/custom/card-custom'
import { PIM_ORG_CHART, PIM_ORG_EXPAND } from '../../router/routes'
import { MdExpand } from 'react-icons/md'
import useThaiInput from '../../helper/input-fix-th'
import useEngInput from '../../helper/input-fix-en'
import useNumberInput from '../../helper/input-fix-num'

function OrganizationSetting() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [orgData, setOrgData] = useState([])
  const [searchOrg, setSearchOrg] = useDebounce('', 1000)
  const [isPopupVisible, setIsPopupVisible] = useState(true)
  const [isRefresh, setIsRefresh] = useState(false)

  let [searchParams, setSearchParams] = useSearchParams()
  const orgId = searchParams.get('orgId')
  const [showCreate, setShowCreate] = useState(false)
  const divisionId = searchParams.get('divisionId')
  const [isSave, setIsSave] = useState(false)

  const inputRef = useRef(null)
  const handleKeyDownTH = useThaiInput(inputRef)
  const handleKeyDownEN = useEngInput(inputRef)
  const handleKeyDownNum = useNumberInput(inputRef)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (roleId) {
      getData()
    }
  }, [roleId, searchOrg])

  const getData = async () => {
    setIsLoading(true)
    const resp = await getGroupsAPI({
      orgId: roleId,
      searchs: searchOrg
    })
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setOrgData(resp.result)
    } else {
      setOrgData([])
    }
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Setting Organization</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <Col xl={12}>
        <CardCustom>
          <div className="p-3">
            <Row>
              <Col
                xl={12}
                className="my-auto d-flex gap-3 justify-content-between"
                style={{ flexWrap: 'wrap' }}
              >
                <label
                  className=" my-auto fw-bold"
                  style={{
                    fontSize: '14px'
                  }}
                >
                  Total: {orgData.length?.toLocaleString()}
                </label>

                {roleId ? (
                  <div className=" d-flex gap-2  justify-content-end">
                    <div className="" style={{ minWidth: '300px' }}>
                      <InputGroup>
                        <InputGroup.Text className="bg-white border-end-0  text-muted">
                          <BsSearch />
                        </InputGroup.Text>
                        <Form.Control
                          className="border-start-0 ps-0 placeholder-text"
                          placeholder="Group/ Group EN/ GroupTH"
                          onChange={(e) => setSearchOrg(e.target.value)}
                        />
                      </InputGroup>
                    </div>
                    <div>
                      <Button size='lg'
                        className="border-0 px-4"
                        onClick={() => setShowCreate(true)}
                      >
                        <BsPlusLg /> Add Group
                      </Button>
                    </div>

                    <Link
                      to={PIM_ORG_EXPAND}
                      className="btn btn-outline-secondary rounded-3 px-3 btn-sm"
                    >
                      <MdExpand className="me-" /> Expand
                    </Link>
                    {/* <Link
                      to={PIM_ORG_CHART}
                      className="btn btn-outline-secondary rounded-3 px-3 btn-sm"
                    >
                      <BsFillDiagram3Fill className="me-" /> Chart
                    </Link> */}
                  </div>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </div>

          <Index
            isLoading={isLoading}
            fnGetData={getData}
            data={orgData}
            setIsRefresh={setIsRefresh}
            isRefresh={isRefresh}
            setIsPopupVisible={setIsPopupVisible}
            isPopupVisible={isPopupVisible}
            orgId={orgId}
            handleKeyDownTH={handleKeyDownTH}
            handleKeyDownEN={handleKeyDownEN}
            handleKeyDownNum={handleKeyDownNum}
          />
        </CardCustom>
      </Col>

      {showCreate && (
        <AddDivsion
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          orgId={orgId}
          param={{ orgId, divisionId }}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetData={getData}
          setShowCreate={setShowCreate}
          handleKeyDownTH={handleKeyDownTH}
          handleKeyDownEN={handleKeyDownEN}
          handleKeyDownNum={handleKeyDownNum}
        />
      )}
    </Row>
  )
}

export default OrganizationSetting
